// 출생 신고 화면용: 원국에서 영역이 차지하는 세력과 게임 시작 능력(초기 스탯)을 나란히 비교한다.
// 서버 응답(statBasis)의 값만 읽고 계산을 바꾸지 않는다. 활용계수로 깎인 이유를 설명하는 문구는 게임 규칙의 설명이다.
import { GROUPS } from './rules.js';

const TEN = [['비견', '겁재'], ['식신', '상관'], ['편재', '정재'], ['편관', '정관'], ['편인', '정인']];
// natalProfile(life.js)의 '활용이 제한됨' 기준과 같다.
const constrainedAt = (field) => (field === '인성' ? 0.8 : 0.65);
const SUPPORT_FIELDS = ['비겁', '인성'];

const NOTE_WEAK_SUPPORT = '이 영역의 기운은 큰 편이지만, 나(일간)를 받쳐 주는 힘이 적어서 처음에는 일부만 쓸 수 있어요.';
const NOTE_ENOUGH_SUPPORT = '이 영역의 기운은 큰 편이지만, 나(일간)를 받쳐 주는 힘이 이미 충분해서 출발 능력에는 덜 반영돼요.';

// 같은 값이면 같은 순위(앞선 사람 수 + 1)
const rankOf = (values, index) => values.filter((v) => v > values[index]).length + 1;

/**
 * 영역마다 { field, share, forceRank, stat, note } 를 돌려준다. 원국 세력 자료가 없으면 null.
 * note 는 세력이 1~2위인데 활용이 제한돼 출발 능력 순위가 더 낮은 영역에만 붙는다.
 */
export function natalGap(saju) {
  const basis = saju?.statBasis, stats = saju?.stats;
  const force = basis?.tenGodForces;
  if (!force || !stats) return null;
  const sums = GROUPS.map((_, i) => TEN[i].reduce((total, key) => total + force[key], 0));
  const total = sums.reduce((a, b) => a + b, 0);
  if (!sums.every(Number.isFinite) || !(total > 0)) return null;
  const statValues = GROUPS.map((field) => stats[field]);
  if (!statValues.every(Number.isFinite)) return null;
  return GROUPS.map((field, i) => {
    const forceRank = rankOf(sums, i), statRank = rankOf(statValues, i);
    const usage = basis.usageFactors?.[field];
    const lowered = forceRank <= 2 && statRank > forceRank && Number.isFinite(usage) && usage <= constrainedAt(field);
    return {
      field, share: sums[i] / total, forceRank, stat: statValues[i],
      note: lowered ? (SUPPORT_FIELDS.includes(field) ? NOTE_ENOUGH_SUPPORT : NOTE_WEAK_SUPPORT) : null,
    };
  });
}
